import React, { useCallback, useContext } from 'react';
import { SingleStepLogger } from '@bingads-webui-campaign-react/step-wizard-logger';
import { ActivityContext } from '@bingads-webui-react/hoc-with-signal';

export const SingleStepLoggerUnderActivity = () => {
  const activity = useContext(ActivityContext);
  const writeStepLog = useCallback((...args) => {
    activity.signal(...args);
  }, [activity]);

  return (
    <SingleStepLogger writeLog={writeStepLog} />
  );
};
